import { useModalMeta } from "@/shared/atoms/useModal";
import useCategoryHook from "@/shared/hooks/useCategoryHook";
import Modal, { ModalProps } from "../Modal/Modal";
import ModalTitle from "../Modal/ModalTitle";
import { useTranslation } from "react-i18next";
import Textfield from "../Input/Textfield";
import { useEffect } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import Button from "../Button/Button";
import { barcodePattern } from "@/shared/utils/patterns";
import AddAndRemoveButtons from "../AddAndRemoveButtons";
import { asArray } from "@/shared/utils/helpers";
import Icon from "../Icon/Icon";

const MenuScanBarcode = ({ onExit, ...props }: ModalProps) => {
  const [{ product, parentId }] = useModalMeta();
  const { productUpdate } = useCategoryHook();
  const { t } = useTranslation();
  const { register, errors, handleSubmit, control } = useForm();
  const { fields, append, remove, insert } = useFieldArray({
    control,
    name: "menuBarcode",
  });

  useEffect(() => {
    if (product?.barcode) {
      const barcode = asArray(product?.barcode);
      barcode.forEach((item, index) => insert(index, { barcode: item }));
    } else {
      append([{ barcode: "" }]);
    }
  }, []);

  useEffect(() => {
    document.getElementById("barcode")?.focus();
  }, []);

  const onFormSubmit = (data) => {
    const submitData = {
      ...product,
      barcode: data.barcode?.filter(Boolean) ?? [],
      parentId: parentId,
    };

    if (productUpdate.isPending) return;
    productUpdate.mutateAsync(submitData, {
      onSuccess: () => onExit(),
    });
  };

  return (
    <Modal {...props} fullHeight onExit={() => onExit()}>
      <ModalTitle>{t("scanAndAddBarcode")}</ModalTitle>
      <form onSubmit={handleSubmit(onFormSubmit)}>
        {fields.map((field, index) => {
          return (
            <AddAndRemoveButtons
              isFirst={index === 0}
              isLast={index === fields.length - 1}
              hasError={Boolean(errors?.barcode?.[`${index}`]?.message)}
              key={field.id}
              onAdd={() => append([{ barcode: "" }])}
              onRemove={() => remove(index)}
              alignItems="flex-start"
            >
              <Textfield
                defaultValue={field?.barcode}
                id="barcode"
                type="text"
                onKeyDown={() => {}}
                inputRightAddon={
                  <Icon
                    className="h-[1.8rem] w-[1.8rem] fill-primary"
                    variants="barcode"
                  />
                }
                name={`barcode[${index}]`}
                ref={register({
                  required: {
                    value: false,
                    message: t("fieldRequired"),
                  },
                  pattern: {
                    value: barcodePattern,
                    message: t("invalidBarcode"),
                  },
                })}
                error={errors?.barcode?.[`${index}`]?.message}
              />
            </AddAndRemoveButtons>
          );
        })}
        <div className="mt-[1rem]" />
        <Button type="submit" isPending={productUpdate.isPending}>
          {t("save")}
        </Button>
      </form>
    </Modal>
  );
};

export default MenuScanBarcode;
